// extracted by mini-css-extract-plugin
export default {"ProductOverview":"ProductOverview_CA789","ProductOverview_item":"ProductOverview_item_XT_qL","ProductOverview_linkWrapper":"ProductOverview_linkWrapper_XO8xP"};